import Router from 'pages';

function App() {
  return (
    <Router />
  );
}

export default App;
